import React from "react";
import styles from "./styles/OutputData.module.css";
/**
 * Data output component
 * The data will be handled as multiple lines if it was an array
 */
const OutputData = ({ label, data, icon: Icon, align, alert }) => {
    return (
        <div className={`${styles.main_output_container} v-flex-container`}>
            {label ? (
                <div className={`${styles.output_label}`}>{label}</div>
            ) : (
                <></>
            )}
            <div
                className={`${styles.output_container}  ${
                    Array.isArray(data) && styles.output_container_list
                } flex-container`}
            >
                {alert ? (
                    <div className={`${styles.alert} flex-container`}></div>
                ) : (
                    <></>
                )}
                {Icon ? (
                    <div className={`${styles.icon_container} flex-container`}>
                        <Icon
                            className={` ${styles.icon}  ${alert ? styles.icon_alert : ""} icon-component`}
                        />
                    </div>
                ) : (
                    <></>
                )}

                <div
                    style={{
                        alignItems:
                            align === "center"
                                ? "center"
                                : align === "right"
                                  ? "flex-end"
                                  : "flex-start",
                    }}
                    className={`${styles.output_data} ${
                        Icon ? styles.output_data_icon_padding : ""
                    } v-flex-container`}
                >
                    {Array.isArray(data) ? (
                        data?.map((line, idx) => (
                            <p key={`${line}${idx}`}>{line}</p>
                        ))
                    ) : data ? (
                        <p>{data}</p>
                    ) : (
                        0
                    )}
                </div>
            </div>
        </div>
    );
};

export default OutputData;
